import { createFileRoute } from '@tanstack/react-router'
import { SuratTemplateManager } from '../../../../components/SuratTemplateManager'

export const Route = createFileRoute('/platform/desa/$desaId/template-surat')({
  component: () => {
    const { desaId } = Route.useParams()
    return <SuratTemplateManager desaId={desaId} />
  },
})
